import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AppointmentStatus, AppointmentStatuses, AppointmentStatusesColors } from '@icc/b2b/shared';

@Component({
    selector: 'icc-appointment-status',
    templateUrl: './appointment-status.component.html',
    styles: [':host { display: inline-block; }'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppointmentStatusComponent {
    private _status: AppointmentStatus;

    @Input()
    get status(): AppointmentStatus {
        return this._status;
    }
    set status(value: AppointmentStatus) {
        this._status = value;
        this.colorRgbHex = AppointmentStatusesColors[value];
        this.name = AppointmentStatuses[value];
    }

    colorRgbHex = '';
    name = '';
}
